// @ts-nocheck
import React, {useContext} from "react";
import {ResponsiveBullet} from "@nivo/bullet";
import ChartCard from "./ChartCard";
import StyleContext from "../../../contexts/StyleContext";
import {meta, overall} from "../data/fifaData";
import {FIFA_PALETTE, getNivoTheme} from "./chartTheme";

// 4.1 Headline win rate (bullet): win rate vs. the 50% coin flip and 81.7%
// ceiling. ranges = [0, coinFlip, ceiling, 100], measures = [winRate],
// markers = [coinFlip, ceiling].

// A single bullet row needs far less than the 400px default.
const HEADLINE_HEIGHT = 170;

// Per-theme colors. ranges map to the three bands (below coin flip / achievable
// / unreachable); markers map to [coinFlip, ceiling].
const COLORS = {
  light: {
    ranges: ["#e9edf0", "#c3e2f2", "#f4f6f8"],
    measure: [FIFA_PALETTE.primary],
    markers: ["#555555", FIFA_PALETTE.accent]
  },
  dark: {
    ranges: ["#2a3342", "#2f5468", "#222a36"],
    measure: ["#5cb3dd"],
    markers: ["#cbd5e1", "#f2792e"]
  }
};

const Swatch = ({color, dashed}) => (
  <span
    aria-hidden="true"
    style={{
      display: "inline-block",
      width: 14,
      height: dashed ? 0 : 12,
      borderRadius: dashed ? 0 : 3,
      borderTop: dashed ? `2px ${dashed} ${color}` : undefined,
      background: dashed ? undefined : color,
      marginRight: 6,
      verticalAlign: "middle"
    }}
  />
);

export default function HeadlineWinRate() {
  const {isDark} = useContext(StyleContext);
  const palette = isDark ? COLORS.dark : COLORS.light;

  const data = [
    {
      id: "winRate",
      title: "",
      ranges: [0, overall.coinFlip, overall.ceiling, 100],
      measures: [overall.winRate],
      markers: [overall.coinFlip, overall.ceiling]
    }
  ];

  const footnote = (
    <span className="fifa-legend">
      <span className="fifa-legend__item">
        <Swatch color={palette.measure[0]} /> Win rate {overall.winRate}%
      </span>
      <span className="fifa-legend__item">
        <Swatch color={palette.markers[0]} dashed="solid" /> Coin flip{" "}
        {overall.coinFlip}%
      </span>
      <span className="fifa-legend__item">
        <Swatch color={palette.markers[1]} dashed="solid" /> Ceiling{" "}
        {overall.ceiling}%
      </span>
      <span className="fifa-legend__note">
        Ceiling is the maximum achievable win rate because draws count as a loss.
        n = {meta.matches} matches ({overall.wins} wins, {overall.draws} draws).
      </span>
    </span>
  );

  return (
    <ChartCard
      title="Headline win rate"
      takeaway={`Backing the higher-ranked team wins ${overall.winRate}% of ${meta.matches} World Cup matches — out of a possible ${overall.ceiling}%.`}
      height={HEADLINE_HEIGHT}
      footnote={footnote}
    >
      <ResponsiveBullet
        data={data}
        margin={{top: 12, right: 28, bottom: 36, left: 12}}
        layout="horizontal"
        spacing={40}
        titleOffsetX={-60}
        measureSize={0.35}
        markerSize={0.75}
        rangeColors={palette.ranges}
        measureColors={palette.measure}
        markerColors={palette.markers}
        axisPosition="after"
        theme={getNivoTheme(isDark)}
        animate={false}
      />
    </ChartCard>
  );
}
